import { render, staticRenderFns } from "./ImsProfitLossSells.vue?vue&type=template&id=218c9f65&"
import script from "./ImsProfitLossSells.vue?vue&type=script&lang=js&"
export * from "./ImsProfitLossSells.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports